module.exports = __webpack_public_path__ + "static/media/view6.820e89b3.jpg";